import React from 'react';

function OrishaReply({ reply }) {
  return (
    <div className="OrishaReply">
      <p>"{reply}"</p>
      <p>— A voice from the Orisha</p>
    </div>
  );
}

export default OrishaReply;
